function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.21875 7C9.21875 5.34315 10.5619 4 12.2188 4C13.8756 4 15.2188 5.34315 15.2188 7C15.2188 8.65685 13.8756 10 12.2188 10C10.5619 10 9.21875 8.65685 9.21875 7ZM12.2188 2C9.45733 2 7.21875 4.23858 7.21875 7C7.21875 9.76142 9.45733 12 12.2188 12C14.9802 12 17.2188 9.76142 17.2188 7C17.2188 4.23858 14.9802 2 12.2188 2ZM8.21875 14C6.89267 14 5.6209 14.5268 4.68322 15.4645C3.74553 16.4021 3.21875 17.6739 3.21875 19V21C3.21875 21.5523 3.66647 22 4.21875 22C4.77103 22 5.21875 21.5523 5.21875 21V19C5.21875 18.2043 5.53482 17.4413 6.09743 16.8787C6.66004 16.3161 7.4231 16 8.21875 16H16.2188C17.0144 16 17.7775 16.3161 18.3401 16.8787C18.9027 17.4413 19.2188 18.2044 19.2188 19V21C19.2188 21.5523 19.6665 22 20.2188 22C20.771 22 21.2188 21.5523 21.2188 21V19C21.2188 17.6739 20.692 16.4021 19.7543 15.4645C18.8166 14.5268 17.5448 14 16.2188 14H8.21875Z",
  fill: "#5C5E6C"
});

var SvgProfile = function SvgProfile(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgProfile, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/profile.0b194afe.svg";
export { ForwardRef as ReactComponent };